.card {
	display: block;
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	overflow: hidden;
	box-shadow: var(--shadow-card);
	text-decoration: none;
	color: inherit;
	transition:
		transform 100ms ease-out,
		box-shadow 100ms ease-out;
}
.card:hover {
	transform: translateY(-2px);
	box-shadow: var(--shadow-card-hover);
	text-decoration: none;
}
.card.pending {
	opacity: 0.55;
	pointer-events: none;
}

/* Feature card: image on top, then a body with the title and a time/effort
   strip below it. Used in the Explore rows and the search results grid. */
.feature {
	display: flex;
	flex-direction: column;
}
.featureImage {
	position: relative;
	aspect-ratio: 3 / 2;
	background: var(--surface-input);
	overflow: hidden;
}
.image {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
.imagePlaceholder {
	width: 100%;
	height: 100%;
	display: grid;
	place-items: center;
	font-size: 2.8rem;
	color: var(--ink-muted);
}
.featureBody {
	padding: var(--space-3);
	display: flex;
	flex-direction: column;
	gap: var(--space-1);
}
.featureTitle {
	margin: 0;
	font-family: var(--font-ui);
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.25;
	color: var(--ink);
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	/* Always reserve two lines so a one-line title's card body matches the
	   height of two-line ones across a row. */
	min-height: 2.5em;
}
.featureMeta {
	display: flex;
	justify-content: space-between;
	gap: var(--space-2);
	font-size: 0.78rem;
	font-weight: 500;
	color: var(--ink-muted);
}
.pendingUrl {
	margin: 0;
	font-size: 0.78rem;
	color: var(--ink-muted);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.taggingBadge {
	position: absolute;
	top: var(--space-2);
	left: var(--space-2);
	font-size: 0.72rem;
	font-weight: 500;
	padding: 2px 8px;
	border-radius: 999px;
	background: rgb(255 255 255 / 0.92);
	color: var(--ink-muted);
}

/* Compact: a horizontal thumbnail + title (+ optional time/effort line), used
   in the View-all list. */
.card.compact {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: var(--space-3);
	padding: var(--space-2);
}
.thumb {
	flex: none;
	width: 56px;
	height: 56px;
	border-radius: var(--radius-md);
	overflow: hidden;
	background: var(--surface-input);
}
.thumbImg {
	width: 100%;
	height: 100%;
	object-fit: cover;
	display: block;
}
.compactBody {
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
}
.compactTitle {
	font-family: var(--font-ui);
	font-size: 0.95rem;
	font-weight: 600;
	color: var(--ink);
	margin: 0;
	line-height: 1.3;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.compactMeta {
	margin: 0;
	font-size: 0.8rem;
	color: var(--ink-muted);
}
